import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageDeliveryBoy,
  ManageDeliveryBoys,
  showMessage,
} from "../../Functionalities/Functions";
import { validateEmail } from "../../Functionalities/Validation";
import AddTopComponent from '../../CoreComponents/AddTopComponent'
import AddBottomComponent from '../../CoreComponents/AddBottomComponent'

function Body() {
  const [disable, setdisable] = useState(false)
  const [data, setData] = useState({
    keyword: "add_deliveryboy",
    username: "",
    name: "",
    email: "",
    password: "",
    cpassword: "",
    mobile: "",
    address1: "",
  });

  const [errors, setErrors] = useState([])

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(errors[0], "danger", " Following fields are required!", "top", "top-right", 0)
    }
  }, [errors]);
  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">

          <AddTopComponent path={"delivery-boys"} />

          <div className="col-xl-12 col-lg-12">
            <div className="card">

              <div className="card-body">
                <div className="basic-form">
                  <form>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Name{" "}
                        <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.name}
                          onChange={(e) =>
                            setData({ ...data, name: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Username{" "}
                        <span className="required">*</span>

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.username}
                          onChange={(e) =>
                            setData({ ...data, username: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Password{" "}
                        <span className="required">*</span>

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="password"
                          className="form-control"
                          value={data.password}
                          onChange={(e) =>
                            setData({ ...data, password: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Confirm Password{" "}
                        <span className="required">*</span>

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="password"
                          className="form-control"
                          value={data.cpassword}
                          onChange={(e) =>
                            setData({ ...data, cpassword: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Email{" "}
                        {/* <span className="required">*</span> */}

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="email"
                          className="form-control"
                          value={data.email}
                          onChange={(e) =>
                            setData({ ...data, email: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Mobile{" "}
                        <span className="required">*</span>

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          min={0}
                          className="form-control"
                          value={data.mobile}
                          onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-' || evt.key === '.') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                          onWheelCapture={e => {
                            e.target.blur()
                          }}
                          maxLength={10}
                          onChange={(e) =>
                            setData({ ...data, mobile: e.target.value.slice(0, 10) })
                          }
                        />
                      </div>
                    </div>

                    <br />
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Address{" "}
                        <span className="required">*</span>

                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.address1}
                          onChange={(e) =>
                            setData({ ...data, address1: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <br />

                    <AddBottomComponent
                      disable={disable}
                      saveButton={(e) => {
                        e.preventDefault();
                        setdisable(true)
                        setErrors([])
                        if (data.name === "") {
                          setdisable(false)
                          setErrors(["Name"])
                          return
                        }
                        if (data.username === "") {
                          setdisable(false)
                          setErrors(["Username"])
                          return
                        }
                        if (data.password === "") {
                          setdisable(false)
                          setErrors(["Password"])
                          return
                        }
                        if (data.password.length < 5) {
                          setdisable(false)
                          setErrors(["Password must be more than 5 characters"])
                          return
                        }
                        if (data.cpassword === "") {
                          setdisable(false)
                          setErrors(["Confirm Password"])
                          return
                        }
                        if (data.cpassword !== data.password) {
                          setdisable(false)
                          setErrors(["Passwords did not match. Please re-enter the password"])
                          return
                        }
                        // if (data.email === "") {
                        //   setdisable(false)
                        //   setErrors(["Email"])
                        //   return
                        // }

                        // if (validateEmail(data.email) === false) {
                        //   setdisable(false)
                        //   setErrors(["Invalid Email"])
                        //   return
                        // }
                        if (data.mobile === "") {
                          setdisable(false)
                          setErrors(["Mobile"])
                          return
                        }
                        if (data.mobile.includes(".")) {
                          setdisable(false)
                          setErrors(["Invalid Mobile"])
                          return
                        }
                        if (data.mobile.length < 10) {
                          setdisable(false)
                          setErrors(["mobile number should be 10"])
                          return
                        }

                        if (data.address1 === "") {
                          setdisable(false)
                          setErrors(["Address"])
                          return
                        }
                        let result = ManageDeliveryBoys(e, "add", data);
                        result.then((res) => {
                          setdisable(false)
                          if (res.data.Status === true) {
                            showMessage("Delivery boy created successfully", "success", "Success!", "top", "top-right", 0)
                            window.location.replace("/delivery-boys")
                          } else {
                            showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0)
                          }
                        });
                      }} />

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddDeliveryBoy() {
  const headers = "Add Delivery Boys";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddDeliveryBoy;
